import { useState } from "react"

import { terminalFieldClassName } from "@/components/terminal/field"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"

// A date a buyer types, in the product's own form (M/D/YY, also M/D/YYYY),
// on the shared field skin: no browser calendar, which follows no design
// system. The value handed back is an ISO day, or null when the field is
// empty; an unreadable entry marks the field invalid with the reason beneath.
const DATE_RE = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})\s*$/

export const parseTypedDate = (text: string): string | null | undefined => {
  if (text.trim() === "") return null
  const match = DATE_RE.exec(text)
  if (!match) return undefined
  const [, m, d, y] = match
  const year = y.length === 2 ? 2000 + Number(y) : Number(y)
  const month = Number(m)
  const day = Number(d)
  const date = new Date(year, month - 1, day)
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  )
    return undefined
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
}

export const DateField = ({
  id,
  value,
  onChange,
  isInvalid = false,
}: {
  id: string
  // The typed text; the caller parses it with parseTypedDate on submit.
  value: string
  onChange: (text: string) => void
  isInvalid?: boolean
}) => {
  const [isTouched, setIsTouched] = useState(false)
  const isUnreadable = isTouched && parseTypedDate(value) === undefined
  return (
    <Input
      id={id}
      inputMode="numeric"
      placeholder="M/D/YY"
      value={value}
      aria-invalid={isInvalid || isUnreadable}
      onChange={(event) => onChange(event.target.value)}
      onBlur={() => setIsTouched(true)}
      className={cn(
        terminalFieldClassName("l", isInvalid || isUnreadable),
        "w-32 tabular-nums"
      )}
    />
  )
}
